// components/common.js
import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';

export const AppBarHeader = ({ title, showBack = false, backLink }) => {
  const navigate = useNavigate();
  const location = useLocation(); // Get current location
  const [anchorEl, setAnchorEl] = useState(null);

  // Open the menu when hamburger is clicked
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Close the menu
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Handle logout with SweetAlert confirmation
  const handleLogout = () => {
    handleMenuClose(); // Close the menu first

    // Get current pathname without query parameters
    const currentPath = location.pathname;

    Swal.fire({
      title: 'กรุณายืนยัน',
      text: 'ต้องการ Logout ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f43d47',
      cancelButtonColor: '#28a745',
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then((result) => {
      if (result.isConfirmed) {
        // Clear token from localStorage
        localStorage.removeItem('token');
        // Navigate to login page with redirect parameter
        navigate(`/login?redirect=${encodeURIComponent(currentPath)}`);
      }
    });
  };

  return (
    <AppBar position="static" color="primary">
      <Toolbar>
        {showBack && (
          <IconButton edge="start" color="inherit" href={backLink}>
            <ArrowBackIcon />
          </IconButton>
        )}
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          {title}
        </Typography>
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleMenuOpen}
          aria-label="menu"
        >
          <MenuIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem
            onClick={handleLogout}
            sx={{
              color: '#f43d47',
              '&:hover': {
                backgroundColor: '#f5222d',
                color: '#fff',
              },
            }}
          >
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};
